import { forwardRef } from 'react'
import { Box, Typography, TextField, FormLabel  } from "@mui/material";
import { styled } from '@mui/material/styles';
import BaseColorText from '../BaseColorText';

const CssTextField = styled(TextField)(({ theme, error, InputProps }) => ({
  '& label.Mui-focused': {
    color: '#5B87EF',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#5B87EF',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: error ? '#ff0404' : InputProps.style?.border,
    },
    '&:hover fieldset': {
      borderColor: InputProps.style?.border,
    },
    '&.Mui-focused fieldset': {
      borderColor: error ? '#ff0404' : '#5B87EF',
    },
  },
}));

const BaseInput = forwardRef(({
  label,
  id,
  fullWidth = false,
  height = 47,
  message,
  error,
  sx,
  inputStyles = {
    color: '#46545F',
    fontWeight: 500,
    fontSize: '15px',
    border: '#ABB7C0',
    borderRadius: '8px',
    background: '#fff'
  },
  InputProps,
  required,
  hasDropdown,
  dropdownOptions,
  handleChangeDropdown,
  selectedDropdownOption,
  ...props
}, ref) => {
  const inputStyle = {
    fontWeight: 500,
    fontSize: '15px',
    border: error ? '#ff0404' : '#ABB7C0',
    borderRadius: '8px',
    background: '#fff',
    ...inputStyles,
    color: error ? '#ff0404' : inputStyles.color,
  }
  return (
    <Box 
      sx={{
        width: '100%',
        display: 'inline-flex',
        flexDirection: 'column',
        ...sx,

        '& .MuiOutlinedInput-notchedOutline': {
          border: `1px solid ${inputStyle.border}`,

          '&:hover': {
            border: `1px solid ${inputStyle.border}`
          }
        },

        '& .MuiOutlinedInput-input': {
          height: height + 'px',
          paddingTop: 0,
          paddingBottom: 0,
        }
      }}
    >
      {label && 
        <FormLabel
          sx={{
            fontSize: '12px',
            fontWeight: 500,
            mb: '1px',
            color: '#46545F'
          }}
          htmlFor={id}
        >
          {label}
          {required && <BaseColorText color='#E73E3E'>*</BaseColorText>}
        </FormLabel>
      }
      <CssTextField
        inputRef={ref}
        autoComplete='off'
        fullWidth={fullWidth}
        InputProps={{
          style: {
            ...inputStyle,
          },
          ...InputProps
        }}
        error={error}
        label={''}
        {...props}
      />
      {hasDropdown &&
        <Box
          sx={{
            border: '1px solid',
            borderColor: 'primary.mainBlue',
            borderRadius: '8px',
            padding: '12px 4px'
          }}
        >
          {dropdownOptions.map((item => (
            <Box
              key={item.value}
              sx={{
                display: 'flex',
                alignItems: 'center',
                bgcolor: selectedDropdownOption === item.value ? 'primary.lightBlue' : 'none',
              }}
            >
              <Typography variant='body'>
                {item.label}
              </Typography>
            </Box>
          )))}
        </Box>
      }
      {message && (
        <Typography>{message}</Typography>
      )}
    </Box>
  )
})

export default BaseInput
